/*
  pss-price-sync.js (2026-10-10, Christian)
  Anlass: 90T-Geraet Single Schwarz 99 EUR, alle anderen Farben 109 EUR. Summary (Geraet / Gesamt /
  Streichpreis / "Du sparst") und Geraete-Kachel waren server-gerendert mit der ERSTEN Hardware-
  Variante (= Schwarz) und zeigten deshalb bei Weiss/Blau/Mint/Beige falsch 99 EUR / -70 EUR,
  waehrend Cart und CTA-% schon korrekt farbabhaengig rechneten.

  Loesung: haengt sich an StarterSetForm.updateSelectedVariantAvailability() (product-form-starter-
  kit-flexplan.js, unveraendert) -- die laeuft bei Seitenladen, Farb- und Planwechsel -- und rechnet
  danach mit der Variante der gewaehlten Farbe neu. Formel 1:1 wie im Liquid (buybuttons-1/2):
    Gesamt     = Pad-Preis (Selling-Plan-Preis, sonst Variant-Preis) + Abo-Geraet (Farbe)
    Streich    = Pad-Vergleichspreis (compare_at > price ? compare_at : price)
                 + Einzelkauf-Geraet (Farbe; sonst compare_at > price ? compare_at : price)
  Findet sich keine passende Farb-Variante, bleibt der Server-Render stehen.
  Hooks: [data-pss-kind] (Summary, buybuttons-2), [data-pss-tile] (Geraete-Kachel, size-selector /
  home-hero-product-flexplan-duo-select).
*/
(function () {
  if (window.__pssPriceSync) return;
  window.__pssPriceSync = true;

  function cents(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'string') {
      var n = parseInt(v.replace('.', ''), 10);
      return isNaN(n) ? null : n;
    }
    var x = Number(v);
    return isNaN(x) ? null : x;
  }

  function selectedColor(inst) {
    var root = inst.colorScopeRoot || document;
    var btn = root.querySelector('.color-btn.checked');
    return btn && btn.dataset.color ? btn.dataset.color.toLowerCase() : null;
  }

  function findByColor(hw, color) {
    if (!hw || !color || !Array.isArray(hw.variants)) return null;
    for (var i = 0; i < hw.variants.length; i++) {
      var v = hw.variants[i];
      if (v && v.option1 && String(v.option1).toLowerCase() === color) return v;
    }
    return null;
  }

  function fmt(inst, c) {
    // 2026-10-25 (Christian): ganze Euro ohne ",00" (wie Collection, Button, Homepage); Cent-Betraege bleiben.
    var s = typeof inst.formatMoney === 'function' ? inst.formatMoney(c) : (c / 100).toFixed(2);
    return String(s).replace(/[.,]00(?=[^0-9]*$)/, '');
  }

  function refreshSummary(inst, box, color) {
    var d = inst.data || {};
    var kind = box.getAttribute('data-pss-kind');
    var isAdd = kind === 'additional';
    // 2026-10-15/16 (12M-Plan): Kind 'annual' = 12M-Karte. Hardware = 90T-Abo-Hardware, Vergleichspreis
    // des Geraets = 90T-Einzelkauf-Geraet (wie Side Cart), siehe annual-card.liquid.
    var isAnn = kind === 'annual';
    if (isAnn && !d.annual_variant) return;
    var pad = isAnn ? d.annual_variant : (isAdd ? d.additional_variant : d.duplicate_product);
    var hw = isAnn ? d.annual_bundle_hardware : (isAdd ? d.additional_bundle_hardware : d.subscription_bundle_hardware);
    var hwOne = isAnn ? d.additional_bundle_hardware_onetime : (isAdd ? d.additional_bundle_hardware_onetime : d.subscription_bundle_hardware_onetime);
    var padV = pad && Array.isArray(pad.variants) ? pad.variants[0] : null;
    var hwV = findByColor(hw, color);
    if (!padV || !hwV) return;

    var padPrice = cents(padV.selling_plan_price);
    if (padPrice == null) padPrice = cents(padV.price) || 0;
    var padBase = cents(padV.price) || 0;
    var padCmp = cents(padV.compare_at_price);
    var padCompare = padCmp != null && padCmp > padBase ? padCmp : padBase;

    var hwPrice = cents(hwV.price) || 0;
    var hwCompare = hwPrice;
    if (hwOne) {
      var oneV = findByColor(hwOne, color) || (Array.isArray(hwOne.variants) ? hwOne.variants[0] : null);
      if (oneV && cents(oneV.price) != null) hwCompare = cents(oneV.price);
    } else {
      var hwCmp = cents(hwV.compare_at_price);
      if (hwCmp != null && hwCmp > hwPrice) hwCompare = hwCmp;
    }

    var total = padPrice + hwPrice;
    var compare = padCompare + hwCompare;
    var hasSave = compare > total;

    var hwEl = box.querySelector('[data-pss-hw]');
    var totalEl = box.querySelector('[data-pss-total]');
    var cmpEl = box.querySelector('[data-pss-compare]');
    var saveEl = box.querySelector('[data-pss-save]');

    if (hwEl) hwEl.textContent = fmt(inst, hwPrice);
    if (totalEl) totalEl.textContent = fmt(inst, total);
    if (cmpEl) {
      cmpEl.textContent = fmt(inst, compare);
      cmpEl.hidden = !hasSave;
    }
    if (saveEl) {
      var span = saveEl.firstElementChild;
      /* 28.10.2026 (Christian): Ersparnis auf volle Betraege abgerundet */
      if (span) span.textContent = 'Du sparst ' + fmt(inst, Math.floor((compare - total) / 100) * 100);
      saveEl.hidden = !hasSave;
    }
  }

  function allInstances() {
    return Array.prototype.filter.call(document.querySelectorAll('purchase-options'), function (el) {
      return el && el.data && typeof el.updateSelectedVariantAvailability === 'function';
    });
  }

  function ownsHardware(inst, pid) {
    var d = inst.data || {};
    return [d.additional_bundle_hardware, d.subscription_bundle_hardware].some(function (h) {
      return h && String(h.product_id) === String(pid);
    });
  }

  function refreshTiles() {
    var tiles = document.querySelectorAll('[data-pss-tile]');
    if (!tiles.length) return;
    var insts = allInstances();
    if (!insts.length) return;

    Array.prototype.forEach.call(tiles, function (tile) {
      // Format: "FARBE=Cent|FARBE=Cent" (klammerfrei, Liquid-sicher)
      var map = {};
      String(tile.getAttribute('data-pss-tile') || '').split('|').forEach(function (pair) {
        var i = pair.lastIndexOf('=');
        if (i > 0) map[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
      });
      var pid = tile.getAttribute('data-pss-pid');
      var owner = null;
      for (var i = 0; i < insts.length; i++) {
        if (ownsHardware(insts[i], pid)) { owner = insts[i]; break; }
      }
      var src = owner || insts[0];
      var color = selectedColor(src);
      if (!color) return;
      var price = null;
      Object.keys(map).forEach(function (k) {
        if (String(k).toLowerCase() === color) price = cents(map[k]);
      });
      if (price != null) tile.textContent = fmt(src, price);
    });
  }

  function sync(inst) {
    var color = selectedColor(inst);
    if (color) {
      Array.prototype.forEach.call(inst.querySelectorAll('[data-pss-kind]'), function (box) {
        refreshSummary(inst, box, color);
      });
    }
    refreshTiles();
  }

  function patch(Ctor) {
    if (!Ctor || !Ctor.prototype) return;
    var proto = Ctor.prototype;
    var orig = proto.updateSelectedVariantAvailability;
    if (typeof orig !== 'function' || orig.__pss) return;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { sync(this); } catch (e) { console.warn('pss-price-sync', e); }
      return r;
    };
    wrapped.__pss = true;
    proto.updateSelectedVariantAvailability = wrapped;
    allInstances().forEach(function (el) {
      try { sync(el); } catch (e) { console.warn('pss-price-sync', e); }
    });
  }

  if (window.customElements && typeof customElements.whenDefined === 'function') {
    customElements.whenDefined('purchase-options').then(function () {
      patch(customElements.get('purchase-options'));
    });
  }
})();
